// src/components/Layout.js
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import UploadModal from './UploadModal';
import Chatbot from './Chatbot'; // Add this import


const Layout = ({ children }) => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  
  const handleFileUpload = (file) => {
    console.log('Uploaded file:', file);
    setShowUploadModal(false);
  };

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
      <UploadModal 
        isOpen={showUploadModal} 
        onClose={() => setShowUploadModal(false)}
        onFileUpload={handleFileUpload}
      />
      <Chatbot /> {/* Add this component */}

    </div>
  );
};

export default Layout;